import { config } from "@fortawesome/fontawesome-svg-core";
import { withProfiler } from "@sentry/react";
import type { FC } from "react";

import type { ServerData } from "@shared/context";
import type { OpenCatalogInitialProps } from "@shared/types/openCatalogInitialProps";
import { ErrorBoundary, Providers } from "@unauthenticated/catalog/components";
import { openCatalogRoutes } from "@unauthenticated/catalog/data/openCatalogRoutes";

import { MainContent } from "./MainContent";

config.autoAddCss = false;
interface Props {
  server?: ServerData;
  initialProps?: OpenCatalogInitialProps;
}

const OpenCatalogMain: FC<Props> = ({ initialProps, server }) => {
  return (
    <Providers {...{ initialProps, server }}>
      <ErrorBoundary to={openCatalogRoutes.catalog}>
        <MainContent />
      </ErrorBoundary>
    </Providers>
  );
};

const OpenCatalogMainWithProfiler = withProfiler(OpenCatalogMain);
export { OpenCatalogMainWithProfiler as OpenCatalogMain };
